import React from "react";

const achievementsData = [
  {
    icon: "🏆",
    title: "Petaverse - Institute Funded Startup",
    description: "Secured institute funding for innovative pet care platform."
  },
  {
    icon: "🎖️",
    title: "GDG Solutions Challenge 2025",
    description: 'Developed "SustainCity" community engagement app for Solution Challenge.'
  },
  {
    icon: "🥇",
    title: "Industrial Training at Tata Steel",
    description: "Hands-on training in BOF steelmaking and refractory wear analysis."
  },
  {
    icon: "🥇",
    title: "OJASS ‘25 - Startup Ideathon Winner",
    description: "Winner (Rank 1) at Startup Ideathon during Ojass ’25, the Annual Techno-Management Fest of NIT Jamshedpur; ranked first in an all-India startup pitch competition with nationwide participation."
  },
  {
    icon: "🥇",
    title: "National Idea Hackathon in E-Summit '25 by E-Cell NIT Jamshedpur",
    description: "Rank 1 winner at the National Idea Hackathon organized by ECELL NIT Jamshedpur."
  },
  {
  icon: "🥇",
  title: "1st Prize – Computer Science & Engineering Department Fest Xavenir",
  description: "Winner (Rank 1) at Xavenir, the premier tech fest of CSE Department, NIT Jamshedpur."
}

];

function Achievements() {
  return (
    <section id="achievements">
      <div className="container">
        <h2 className="section-title">Achievements</h2>
        <div className="achievements-grid">
          {achievementsData.map(({ icon, title, description }, idx) => (
            <div key={idx} className="achievement-card">
              <div className="achievement-icon">{icon}</div>
              <h4>{title}</h4>
              <p>{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Achievements;
